import React from 'react';
import BaseSheet from '../../Common/Layout/BaseSheet';
import Upload from '../../Common/Upload';

interface ManageContestsSheetProps {
    disabled: boolean;
    onUpload(file: File): Promise<{ success: boolean; errorMessage?: string }>;
}

export default function ManageContestsSheet({ disabled, onUpload }: ManageContestsSheetProps) {    

  return (
    <BaseSheet id='manage-contests-container'>
      <Upload
        fileType={'zip'}
        disabled={disabled}
        onUpload={onUpload}
      />
    </BaseSheet>
  );
}
